(function(){
  var brand = document.body.getAttribute('data-brand');
  if (!brand) return;

  var configs = {
    mdrea: {
      bg: '15,15,16',
      fg: '245,243,240',
      accent: '214,198,165',
      gradient: '#0F0F10',
      fgRaw: '#F5F3F0',
      accentRaw: '#D6C6A5',
      scheme: 'dark'
    },
    meguru: {
      bg: '247,245,242',
      fg: '15,15,16',
      accent: '180,122,79',
      gradient: '#F7F5F2',
      fgRaw: '#0F0F10',
      accentRaw: '#F6E96B',
      scheme: 'light'
    },
    frola: {
      bg: '255,249,245',
      fg: '74,46,46',
      accent: '200,161,90',
      gradient: '#FFF9F5',
      fgRaw: '#4A2E2E',
      accentRaw: '#C8A15A',
      scheme: 'light'
    }
  };

  var c = configs[brand];
  if (!c) return;

  // Apply immediately (before paint if possible)
  var style = document.createElement('style');
  style.id = 'soireve-brand-override';
  style.innerHTML = [
    'body[data-brand=' + brand + ']{',
    '  --color-background:' + c.bg + '!important;',
    '  --gradient-background:' + c.gradient + '!important;',
    '  --color-foreground:' + c.fg + '!important;',
    '  --color-button:' + c.fg + '!important;',
    '  --color-button-text:' + c.bg + '!important;',
    '  background-color:rgb(' + c.bg + ')!important;',
    '  color:rgb(' + c.fg + ')!important;',
    '}',
    'body[data-brand=mdrea] .card-wrapper .card,',
    'body[data-brand=mdrea] .card__inner{',
    '  background-color:#1A1A1B!important;',
    '  border-color:rgba(214,198,165,0.15)!important;',
    '}',
    'body[data-brand=mdrea] .card__heading a,',
    'body[data-brand=mdrea] .card__information .card__heading a{color:#F5F3F0!important}',
    'body[data-brand=mdrea] .price__regular .price-item,',
    'body[data-brand=mdrea] .price{color:#D6C6A5!important}',
    'body[data-brand=mdrea] a,body[data-brand=mdrea] .breadcrumbs a{color:#D6C6A5!important}',
    'body[data-brand=meguru] .card-wrapper .card,',
    'body[data-brand=meguru] .card__inner{',
    '  background-color:#FFFFFF!important;',
    '  border-radius:12px!important;',
    '}',
  ].join('\n');
  
  // Insert as FIRST child of head to allow later rules to override if needed
  var head = document.head || document.documentElement;
  var firstStyle = head.querySelector('style,link');
  if (firstStyle) {
    head.insertBefore(style, firstStyle);
  } else {
    head.appendChild(style);
  }

  // Also apply directly to the document element and body for belt-and-suspenders
  document.documentElement.style.setProperty('--color-background', c.bg, 'important');
  document.body.style.setProperty('--color-background', c.bg, 'important');
  document.body.style.setProperty('--gradient-background', c.gradient, 'important');

  // DOMContentLoaded: force background after all CSS settles
  function applyBrand() {
    document.body.style.setProperty('background-color', 'rgb(' + c.bg + ')', 'important');
    document.body.style.setProperty('color', 'rgb(' + c.fg + ')', 'important');
    // Move our override style to end of head so it wins via source order
    var existing = document.getElementById('soireve-brand-override');
    if (existing) {
      document.head.appendChild(existing);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyBrand);
  } else {
    applyBrand();
  }
  // Also run after full load for any JS-rendered elements
  window.addEventListener('load', applyBrand);
})();